import { useAuthStore } from '../../../store';
import HeaderFilter from '../../../components/HeaderFilter';
import PartnerForm from '../PartnerForm';
import PartnerTable from '../PartnerTable';

const BuyerPage = () => {
  const api = 'partner/buyers';
  const moduleName = 'Buyer';
  const moduleCode = 'BUYER';

  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );
  return (
    <>
      <div className={'page-wrapper'}>
        <HeaderFilter showCreate={userModuleAccess?.create} />
        <PartnerForm api={api} moduleName={moduleName} />
        <PartnerTable
          api={api}
          moduleName={moduleName}
          moduleCode={moduleCode}
        />
      </div>
    </>
  );
};

export default BuyerPage;
